<template>
  <v-container fluid>
    <div>Export Data</div>
  </v-container>
</template>

<script>
const download_csv = function(arr) {
  var str = '';
  arr.forEach(rw => {
    let line = '';
    line = rw.join(",");
    str += line + '\r\n';
  });
  var blob = new Blob([str], { type: 'text/csv;charset=utf-8;' });

  const link = document.createElement('a');
  const url = URL.createObjectURL(blob);
  link.setAttribute('href', url);
  link.setAttribute('download', 'oxygen_demand_history.csv');
  link.style.visibility = 'hidden';
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
}

export default {
  name: 'HomeEcuadorReport',

  data: () => ({}),

  methods: {
    prepare_data: function(data) {
      const fields = ['id', 'created_at', 'loc_id', 'Location', 'date', 'device', 'rate', 'leak', 'bias', 'fio2', 'rr', 'expiratory', 'liters', 'patients']
      //let export_dat = [fields.map(x => this.$t(x))] // do not want translated column headers
      let export_dat = [fields]
      data.forEach( d => {
          let row = []
          fields.forEach( (ky) => {
            if(ky === "device") {
              // translate device
              row.push(this.$t(d[ky]))
            } else {
              row.push(d[ky])
            }
          })
          export_dat.push(row)
      })

      return export_dat
    },
    download: function() {
      fetch('/.netlify/functions/unique_demand')
        .then(response => {
          response.json().then((data) => {download_csv(this.prepare_data(data))})
        })
        .catch(function(error) {
          console.log(error)
        })
    },
  },

  mounted: function() {
    this.download()
  },

}
</script>